import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Submit from './pages/Submit';
import HackDetail from './pages/HackDetail';
import SubmitConfirmation from './pages/SubmitConfirmation';
import WordPressSetup from './components/WordPressSetup';
import { ApolloProvider } from '@apollo/client';
import { wpClient } from './lib/wordpress';
import { ErrorBoundary } from 'react-error-boundary';

function ErrorFallback({ error }: { error: Error }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-2xl font-bold text-red-600 mb-4">Something went wrong</h2>
        <p className="text-gray-600 mb-4">
          {error.message.includes('Apollo') 
            ? 'Unable to connect to WordPress. Please check your connection settings.'
            : error.message}
        </p>
        <button 
          onClick={() => window.location.reload()} 
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <ApolloProvider client={wpClient}>
        <Router>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/browse" element={<Browse />} />
                <Route path="/submit" element={<Submit />} />
                <Route path="/hack/:id" element={<HackDetail />} />
                <Route path="/setup" element={<WordPressSetup />} />
                <Route path="/submit-confirmation" element={<SubmitConfirmation />} />
              </Routes>
            </main>
            <Footer />
            <Toaster />
          </div>
        </Router>
      </ApolloProvider>
    </ErrorBoundary>
  );
}

export default App;
